export class DisponibiliteClient {

    From: Date;
    To: Date;

    static mapFromJSON(json) {
        const cm = new DisponibiliteClient;

        cm.From = new Date(json['from']);
        cm.To = new Date(json['to']);

        return cm;
    }
}
